import { createGlobalStyle } from 'styled-components';
import ListPages from './components/ListPages/index';
import Name from './components/Name/index';
import Apresentation from './components/Presentation';
import { useRecoilState } from 'recoil';
import { StateStatus } from './StorageStates/index';
import { useLocation } from 'react-router-dom';
import Resumo from './components/Resumo/index';
import FadeIn from 'react-fade-in';
import Projetos from './components/projetos/index';
import Contatos from './components/contatos/index';

export const GlobalStyleProject = createGlobalStyle`
  *{
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;

    
  }
  body{
    background-color : ${(props) => props.backgroundColor}
    
  }

`;

function App() {
    const [state, setState] = useRecoilState(StateStatus);
    const location = useLocation();
    return (
        <>
            <GlobalStyleProject
                backgroundColor={state ? '#151515' : '#FFFFFF'}
            />
            <Name isToogle={state} />
            <ListPages
                SubsColors={state}
                click={() =>
                    (state && setState(false)) || (!state && setState(true))
                }
            />
            {location.pathname === '/' && <Apresentation displayS={'grid'} />}
            {location.pathname === '/resumo' && (
                <FadeIn duration={500}>
                    <Resumo displayResume={'grid'} />
                </FadeIn>
            )}
            {location.pathname === '/projetos' && (
                <FadeIn duration={100}>
                    <Projetos />
                </FadeIn>
            )}
            {location.pathname === '/contatos' && (
                <FadeIn duration={500}>
                    <Contatos/>
                </FadeIn>
            )}
        </>
    );
}

export default App;
